import { VERTICAL_NAMES } from "../constants/constants";

const normalizeIlResponse = (res) => {
  return {
    data: {
      accounts: Array.isArray(res?.accounts) ? res.accounts : [],
    },
  };
};

const normalizeScaResponse = (res) => {
  return {
    data: {
      accounts: Array.isArray(res?.accounts) ? res.accounts : [],
    },
  };
};

const normalizeIlSchoolsResponse = (res) => {
  return {
    data: {
      accounts: Array.isArray(res?.accounts) ? res.accounts : [],
    },
  };
};

const normalizeMetaResponse = (res, verticalId) => {
  const data = res?.data;
  if (!data) return { data: { accounts: [] } };
  const dataArray = Array.isArray(data) ? data : [data];

  return {
    data: {
      accounts: dataArray.map((item) => ({
        firstName: item.firstName,
        lastName: item.lastName,
        phone: item.phone,
        gradeId: item.gradeId,
        profiles: [
          {
            uamId: item.uamId,
            admissionId: item.admissionNumber,
            verticalId: verticalId,
            crnId: item.crnId,
          },
        ],
      })),
    },
  };
};

const normalizeInmobiusResponse = (res, verticalId) => {
  const data = res?.data;
  if (!data) return { data: { accounts: [] } };
  const dataArray = Array.isArray(data) ? data : [data];

  return {
    data: {
      accounts: dataArray.map((item) => ({
        firstName: item.firstName,
        lastName: item.lastName,
        phone: item.phone,
        gradeId: item.gradeId,
        profiles: [
          {
            uamId: item.uamId,
            admissionId: item.admissionId,
            verticalId: verticalId,
            crnId: item.crnId,
          },
        ],
      })),
    },
  };
};

export const normalizeSearchUserResponse = (res, verticalInfo) => {

  const verticalName = verticalInfo?.name;
  const verticalId = verticalInfo?.id;

  switch (verticalName) {
    case VERTICAL_NAMES.IL:
      return normalizeIlResponse(res);
    case VERTICAL_NAMES.SCA:
      return normalizeScaResponse(res);
    case VERTICAL_NAMES.INMOBIUS:
      return normalizeInmobiusResponse(res, verticalId);
    case VERTICAL_NAMES.META:
      return normalizeMetaResponse(res, verticalId);
    case VERTICAL_NAMES.META_JR:
      return normalizeMetaResponse(res, verticalId);
    case VERTICAL_NAMES.IL_SCHOOLS:
      return normalizeIlSchoolsResponse(res);
    default:
      return { data: { accounts: [] } };
  }
};

const searchUserResponseAdapter = (account, profile) => {
  if (!account || !profile) return null;

  return {
    first_name: account.firstName,
    last_name: account.lastName,
    uam_id: profile.uamId,
    phone: account.phone,
    admission_number: profile.admissionId,
    grade_id: account.gradeId,
    crn_id: profile.crnId,
  };
};

export default searchUserResponseAdapter;
